import React from 'react';
import { Component } from 'react';

import styles from '../styles/GameSounds.css';

export default class GameSounds extends Component {

  constructor () {
    super();

    this.enabled = typeof Audio !== "undefined";

    this.state = {
      mute: false
    }

    this.audio = null;
    this.url = "";
  }

  componentDidMount () {
    this.doImperitiveStuff();
  }

  componentDidUpdate () {
    this.doImperitiveStuff();
  }

  doImperitiveStuff() {

    if (!this.enabled) return;

    let url;

    if(this.state.mute){
      url = "";
    } else {
      url = require('../snd/background.mp3');
    }

    if(this.url != url){
      this.audio.src = url;
      this.url = url;
    }
    else {
      this.audio.play();
    }

  }

  toggleMute () {
    this.setState({mute: !this.state.mute});
  }

  render () {
    const img = this.state.mute ? require('../img/Misc/speaker-no.png') : require('../img/Misc/speaker.png');

    return this.enabled ? (
      <div className={styles.icon}>
        <img src={img} onClick={()=>this.toggleMute()} />
        <audio autoPlay={true} loop={true} ref={(e)=>this.audio=e}/>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/GameSounds.js